'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var prefix = 'fas';
var iconName = 'mango';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e30f';
var svgPathData = 'M376 0h8 24 8 56c39.8 0 72 32.2 72 72c0 13.3-10.7 24-24 24H480c-33.4 0-62.8-17-80-42.9v49c32.2 8.3 62.6 25 87.8 50.2C525.3 189.7 544 238.9 544 288c0 76.6-57.5 224-224 224c-144 0-244.1-43.3-244.1-43.3c-33.5-11.1-51.7-47.3-40.6-80.9C39.4 375.4 47 365 56.7 357.5c34.3-25.7 52.1-57.6 71.2-91.8c20.6-36.8 42.6-76.3 88.4-113.5C253.7 114.7 302.9 96 352 96V24c0-13.3 10.7-24 24-24zm88 304c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 53-43 96-96 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c70.7 0 128-57.3 128-128z';
exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, aliases, unicode, svgPathData]
};
exports.faMango = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;